"use client"

import { useId, useState, type InputHTMLAttributes } from "react"
import { Eye, EyeOff } from "lucide-react"
import { cn } from "@/shared/lib/utils"

interface KolomTeksProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
  label: string
  value: string
  onChange: (nilai: string) => void
  petunjuk?: string
}

export function KolomTeks({ label, value, onChange, petunjuk, className, ...sisa }: KolomTeksProps) {
  const id = useId()
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-xs font-medium text-muted-foreground">
        {label}
      </label>
      <input id={id} value={value} onChange={(event) => onChange(event.target.value)} className={cn("field", className)} {...sisa} />
      {petunjuk && <p className="mt-1.5 text-xs text-muted-foreground">{petunjuk}</p>}
    </div>
  )
}

interface KolomPasswordProps {
  label: string
  value: string
  onChange: (nilai: string) => void
  autoComplete: "current-password" | "new-password"
  disabled?: boolean
  petunjuk?: string
}

export function KolomPassword({ label, value, onChange, autoComplete, disabled, petunjuk }: KolomPasswordProps) {
  const id = useId()
  const [terlihat, setTerlihat] = useState(false)

  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-xs font-medium text-muted-foreground">
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={terlihat ? "text" : "password"}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          disabled={disabled}
          maxLength={128}
          className="field pr-12"
        />
        <button
          type="button"
          onClick={() => setTerlihat((nilai) => !nilai)}
          aria-label={terlihat ? "Sembunyikan password" : "Tampilkan password"}
          className="absolute inset-y-0 right-1.5 my-auto grid h-9 w-9 place-items-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {terlihat ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
      {petunjuk && <p className="mt-1.5 text-xs text-muted-foreground">{petunjuk}</p>}
    </div>
  )
}

export function PesanGalat({ pesan }: { pesan: string | null }) {
  if (!pesan) return null
  return (
    <p role="alert" className="rounded-xl border border-destructive/25 bg-destructive/10 px-3.5 py-2.5 text-xs font-medium text-destructive">
      {pesan}
    </p>
  )
}
